export default __webpack_public_path__ + "static/media/logo.75dcff2b.svg";